import { validateForUI } from 'common/helpers/jsonValidator';

const updateCartSchema = {
  type: 'object',
  properties: {
    quantity: { type: 'integer', minimum: 1 }
  },
  required: ['quantity'],
  additionalProperties: false
};

export const validateUpdateCart = (params, t) => {
  const errors = validateForUI(updateCartSchema, params, null, t);
  return errors;
};
